export default {
  slot: null,
  fee: null,
  group: null,
}
